import { createApp, capitalize } from 'vue';
import { createPinia } from 'pinia';
import ui from '@nuxt/ui/vue-plugin';
import { addCollection } from '@iconify/vue';
import lucideIcons from '@iconify-json/lucide/icons.json';
import App from './App.vue';
import router from './router';
import './index.css';
import { Tabs, Tab } from 'vue3-tabs-component';
import { useEnvironment } from './composables/useEnvironment';
import { handlePreloadError } from './utils/appReload';

addCollection(lucideIcons);

// Fires for every lazy import a deploy left unreachable; the default is left in
// place deliberately — see utils/appReload.js (CPRD-5916).
window.addEventListener('vite:preloadError', handlePreloadError);

// ApexCharts merges window.Apex into every chart's config, so this is the one
// place to set chart-wide defaults. chart.fontFamily is the fallback for axis
// labels, legend, data labels, and tooltips — CSS can't do it, since ApexCharts
// writes font-family inline on the SVG text elements.
window.Apex = { chart: { fontFamily: 'Nunito, sans-serif' } };

const pinia = createPinia();
const app = createApp(App).component('tabs', Tabs).component('tab', Tab);

const { isProd, isDemo } = useEnvironment();

app.config.globalProperties.window = window;

app.use(router).use(pinia).use(ui).mount('#app');

if (!isProd() || !isDemo()) {
  window.__pinia = pinia;
}

document.title = `Auxo${
  import.meta.env.VITE_CLIENT_PREFIX
    ? ` - ${capitalize(import.meta.env.VITE_CLIENT_PREFIX)}`
    : ''
}`;
